import { SelectedInstrument } from "helpers/types/instruments/selected"
import useResource from "hooks/resources"

export interface TagCategory {
  id: string
  name: string
}

export function useTagCategories(instrument: SelectedInstrument) {
  return useResource<TagCategory[]>({
    resource: `tagCategories-${instrument?.id}`,
    url: () => {
      if (!instrument?.id || instrument?.type !== "PORTFOLIO") {
        return null
      }
      return {
        id: `tagCategories-${instrument.id}`,
        query: `query ($portfolioId: String!) {
          portfolio(id: $portfolioId) {
            tagCategories {
              id
              name
            }
          }
        }`,
        variables: { portfolioId: instrument.id },
      }
    },
  }, ["portfolio", "tagCategories"])
}
